import { useEffect } from "react";

export const WIP = () => {
    useEffect(() => {
        document.title = "Work in Progress | CaseDB";
    }, []);

    return (
        <div className='page-container'>This page is currently being built!</div>
    );
};